module.exports = __webpack_public_path__ + "img/j_ava.69e1448e.jpg";